import script from "./SubmitButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubmitButton.vue?vue&type=script&setup=true&lang=ts"

import "./SubmitButton.vue?vue&type=style&index=0&id=81ba9090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81ba9090"]])

export default __exports__